import { useState } from "react";

import { UpdateIconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, pn, formatDate } from "@compass/core";

import { ListBeProperty } from "components";
import { Permission, PermissionAction, SortObject, SurveyListDto, SurveyListResource, SurveyReportListDto } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { surveyReportPageRoute } from "../SurveyReports/SurveyReportPage";

export const SurveyReportTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  surveyReports: SurveyReportListDto[];
  resource: SurveyListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell type="id">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SurveyReportListDto>("createdDate"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SurveyReportListDto>("name"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<SurveyReportListDto>("fileName"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.surveyReports.map((survey) => (
            <TableRow
              key={survey.id}
              onClick={() => navigate(surveyReportPageRoute.getPath({ id: survey.id, crudMode: "view" }))}
            >
              <TableCell>{formatDate(survey.createdDate)}</TableCell>
              <TableCell>{survey.name}</TableCell>
              <TableCell>{survey.fileName}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton color="primary"
                      onClick={() => navigate(surveyReportPageRoute.getPath({ id: survey.id, crudMode: "view" }))}
                    />
                  )}
                </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
